<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-20 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>
              일괄 처리 입력
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="flex-div">
              <h5 class="title">엑셀 업로드</h5>
              <div class="inline-flex mb10">
                <input v-focus type="file" class="hidden-input-file" id="bundleFileInput" accept=".xlsx">
                <input type="text" v-model="excelFileName" disabled>
                <button v-focus @click="onClickSearchExcel">
                  <md-icon>search</md-icon>엑셀 파일 찾기
                </button>
              </div>
              <md-button class="md-success md-sm full-size-button" @click="uploadExcelFile" :disabled="!excelFile">
                <md-icon>publish</md-icon>
                엑셀 업로드
              </md-button>
            </div>
            <hr>
            <div class="flex-div">
              <h5 class="title">대상 복사 붙여 넣기</h5>
              <div class="inline-flex mb10">
                <textarea rows="8" class="h150" v-model="textAreaData"></textarea>
              </div>
              <div class="inline-flex mb10">
                <select v-model="selectedQueryType">
                  <option value="memberNoStr">교우번호</option>
                  <option value="hakbunStr">학번</option>
                </select>
              </div>
              <md-button class="md-success md-sm full-size-button" :disabled="String(textAreaData).trim().length < 7" @click="uploadMemberList">
                <md-icon>publish</md-icon>실행
              </md-button>
            </div>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>
              일괄 처리 정보
            </h4>
          </md-card-header>
          <md-card-content>
            <div :class="{ mb10 : isShowForm }">
            <md-button class="md-info md-sm full-size-button" @click="() => { this.isShowForm = !this.isShowForm }">
              <md-icon>check</md-icon>
              일괄처리 정보입력 {{ this.isShowForm ? "닫기": "열기" }}
            </md-button>
            </div>
            <table class="flex-table" v-if="isShowForm">
              <tr>
                <th>입금처리일</th>
                <td>
                  <div class="inline-flex">
                    <input type="text" v-model="info.feeDate" v-mask="'####-##-##'">
                  </div>
                </td>
              </tr>
              <tr>
                <th>회비구분</th>
                <td>
                  <select v-model="selectedFeeCd" @change="changeFeeCd">
                    <option value="">선택</option>
                    <option v-for="item in feeCdList" :key="item.code"  v-bind:value="item" :label="item.codeNm"></option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>회비년도</th>
                <td>
                  <input type="text" v-model="info.feeYear" v-mask="'####'">
                </td>
              </tr>
              <tr>
                <th>납입금액</th>
                <td>
                  <input type="text" v-model="info.feeAmt">
                </td>
              </tr>
              <tr>
                <th>납부방법</th>
                <td>
                  <div class="inline-flex">
                    <select v-model="info.feeWay">
                      <option value="">선택</option>
                      <option
                        v-for="item in feeWayList"
                        :key="item.code"
                        :value="item.code"
                        :label="item.codeNm"
                      ></option>
                    </select>
                    <span v-show="info.feeWay == '03'">은행</span>
                    <select v-model="info.bankCd"  v-show="info.feeWay == '03'">
                      <option value="">선택</option>
                      <option v-for="item in bankCdList" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <th>비고</th>
                <td>
                  <textarea
                    v-model="info.feeEtc"
                  ></textarea>
                </td>
              </tr>
            </table>
          </md-card-content>
          <md-card-actions md-alignment="right" v-if="isShowForm">
            <md-button class="md-info md-sm full-size-button" @click="bundleUpdate">
              <md-icon>check</md-icon>
              회비 일괄처리 전송
            </md-button>
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-size-80 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>
              납부 상세 내역
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="table-header-info">
              <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
              <div>
                <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                  <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                    {{ item }}
                  </option>
                </select>
              </div>
            </div>

            <grid ref="executivesGrid"
                  :data="gridProps.data"
                  :columns="gridProps.columns"
                  :options="gridProps.options"
                  :theme="gridProps.theme"
                  :rowHeaders="gridProps.rowHeaders"
                  :columnOptions="gridProps.columnOptions"
                  :language="gridProps.lang"
                  @response="response"
            ></grid>

          </md-card-content>
          <md-card-actions md-alignment="right">
          </md-card-actions>
        </md-card>


      </div>
    </div>
  </div>
</template>

<script>
  import api from "@/kuaa/kuaa-api";
  import URL_CONST from "@/kuaa/kuaa-url-const";
  import parser from "@/kuaa/kuaa-parser";
  import kuaaFnc from "@/kuaa/kuaa-comm-func";
  import Swal from "sweetalert2";
  import moment from "moment";

  import { Grid } from '@toast-ui/vue-grid';

  export default {
    components: {
      grid: Grid
    },

    created() {
      this.queryFeeYear();
      this.queryFeeCd();
      this.queryFeeWay();
      this.queryBankCdTypes();
      this.initGrid();
    },

    computed: {
      total() {
        return this.pagination.total;
      }
    },

    data(){
      return{
        api,

        feeYearList: [],
        feeCdList: [],
        feeWayList: [],
        bankCdList: [],

        selectedFeeCd : null,

        isShowForm: false,


        excelFile: null,
        excelFileName: null,
        textAreaData: "",
        gridProps: {},
        pagination: {
          perPage: 20,
          page: 1,
          perPageOptions: [20, 50, 100, 200, 500],
          total: 0
        },
        selectedQueryType: "memberNoStr",// 교우번호 조회/학번 조회

        info: {
          cellular : "",
          feeDate: moment().format("YYYYMMDD"), // 입금처리일
          feeCd: "", // 회비 구분(코드)
          feeCdNm: "", // 회비 구분(코드)
          feeYear: new Date().getFullYear(), // 회비년도
          feeAmt: "", // 납입금액
          feeWay: "",// 납부 방법
          bankCd: "",
          feeEtc: "",// 비고
          feeGb : "01",
          orgFeeCd: ""
        }
      };
    },
    methods: {

      initGrid() {
        this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_MEMBER_LIST, false, this.pagination, ['rowNum','checkbox']);
        this.gridProps['el'] = this.$refs.executivesGrid;
        this.gridProps['columns']= [
            {header: '교우번호', name: 'memberNo', sortable: true},
            {header: '교우명', name: 'memberHnm', sortable: true},
            {header: '교우직위명', name: 'memberorgGb', sortable: true},
            {header: '한자명', name: 'memberCnm', sortable: true},
            {header: '대학명', name: 'collegeCd', sortable: true},
            {header: '학과명', name: 'classCdNm', sortable: true},
            {header: '졸업회수', name: 'graduationNo', sortable: true},
            {header: '입학년월', name: 'enterYm', sortable: true},
            {header: '졸업년월', name: 'graduationYm', sortable: true},
            {header: '학번', name: 'hakbun', sortable: true},
          ];
        this.gridProps['options'].bodyHeight = 570;
      },

      /**
       * 회비년도는 현재년도로부터 과거 10년
       */
      queryFeeYear() {
        let thisYear = new Date().getUTCFullYear();
        let yearList = [];
        for(let i = 0; i < 10; i++){
          yearList.push(thisYear - i)
        }
        this.feeYearList = yearList;
      },

      /**
       * 납입구분코드
       */
      queryFeeCd() {
        kuaaFnc.fncFeeCdTypes(null,res => {
          this.feeCdList = res.data.data.contents;
        });
      },

      /**
       * 납부방법코드 조회
       */
      queryFeeWay() {
        kuaaFnc.fncFeeWayTypes(null,res => {
          this.feeWayList = res.data.data.contents;
        });
      },

      /**
       * 납부방법코드 - 공통코드 조회 세팅
       */
      queryBankCdTypes() {
        kuaaFnc.fncBankCodes(null,res => {
          this.bankCdList = res.data.data.contents;
        });
      },

      onClickSearchExcel() {
        let input = document.getElementById("bundleFileInput");
        input.onchange = e => {
          let file = e.target.files[0];
          this.excelFileName = file.name;
          this.excelFile = file;
        };
        input.click();
      },

      uploadExcelFile() {
        parser.parseXlsMemberData(this.excelFile, (res)=>{
          let str = res.join("|");
          this.getMemberList(str);
        });
      },

      uploadMemberList() {
        let list = this.textAreaData.split("\n");
        let str = list.join("|");
        this.getMemberList(str);
      },

      getMemberList(memberNoArr){
        let options = {};
        if(this.selectedQueryType == "memberNoStr"){
        	options.memberNoStr = memberNoArr
        	options.hakbunStr = null
        }
        if(this.selectedQueryType == "hakbunStr"){
        	options.memberNoStr = null
        	options.hakbunStr = memberNoArr
        }
        
        this.$refs.executivesGrid.invoke("readData", 1, options, true);
      },

      clearForm() {
        this.info = {
          feeDate: null, // 입금처리일
          feeCd: "", // 회비 구분(코드)
          feeCdNm: "", // 회비 구분(코드)
          feeYear: new Date().getFullYear(), // 회비년도
          feeAmt: "", // 납입금액
          feeWay: "",// 납부 방법
          bankCd: "",
          feeEtc: "",// 비고
          feeGb : "01",
          cellular : ""
        };
      },

      /**
       * 회비 일괄처리 전송 (버튼클릭)
       */
      bundleUpdate(e){
        let _this = this;

        if(!this.info.feeWay || this.info.feeWay == ''){
          Swal.fire(kuaaFnc.getSwalModaloptions({
            html: "납부방법을 선택 하세요.",
          }))
          return;
        }

        if(this.info.feeWay  == '03' && (!this.info.bankCd || this.info.bankCd == '')){
          Swal.fire(kuaaFnc.getSwalModaloptions({
            html: "은행을 선택 하세요.",
          }))
          return;
        }

        let modalOptions = {
          title: "납부 내역 저장",
          type: "warning",
          showCancelButton: false,
          confirmButtonClass: "md-button md-info",
          cancelButtonClass: "md-button md-default",
          confirmButtonText: "확인",
          buttonsStyling: false
        };

        let options = [];
        let checkItems = this.$refs.executivesGrid.invoke('getCheckedRows');
        if(checkItems.length == 0){
          modalOptions.html = `대상 회원을 선택 해 주세요.`;
          Swal.fire(modalOptions);
          return;
        }
        checkItems.forEach(item => {
          options.push({
          	cellular : item.cellular,
            memberNo: item.memberNo,
            memberHnm : item.memberHnm,
            feeDate: this.customFormatter(this.info.feeDate), // 입금처리일
            feeCd: this.info.feeCd, // 회비 구분(코드)
            feeCdNm: this.info.feeCdNm, // 회비 구분(코드)
            feeYear: this.info.feeYear, // 회비년도
            feeAmt: this.info.feeAmt, // 납입금액
            feeWay: this.info.feeWay,// 납부 방법
            bankCd: this.info.bankCd,
            feeEtc: this.info.feeEtc,// 비고
            feeGb : "01",
            orgFeeCd: ""
          });
        });
        
        api.sendServer(
          URL_CONST.SAVE_FEE_LIST,
          options,
          "post",
          response => {

            if (response.data.success){
              this.clearForm();

              Swal.fire(kuaaFnc.getSwalModaloptions({html: options.length + ' 건의 납부 내역이 처리 되었습니다.'}));

/*
              //알림톡 발송 - 주석처리
              if (e) {
                e.stopPropagation();
                e.preventDefault();
              }

              _this.sendKakaoTalk(options).then(function () {
                setTimeout(() => {
                  _this.resetView();
                  Swal.fire(kuaaFnc.getSwalModaloptions({html: options.length + ' 건의 납부 내역이 처리 되었습니다.'}));
                }, 1000);

              }).catch(error => {
              });
*/
            } else {

              modalOptions.html = `납부 내역 저장에 실패 하였습니다.`;
              Swal.fire(modalOptions);
            }
          }
        )
      },
      response(e) {
        let res = JSON.parse(e.xhr.response);
        if(res.result){
          this.pagination.total = res.data.pagination.totalCount;
        }else{
          kuaaFnc.gridErrorCallback(e);
        }
      },
      perPageChange(event) {
        kuaaFnc.resetPagenation(this.$refs.executivesGrid, event, this.pagination);
      },
      customFormatter(date) {
        let res = date && date != '' ? moment(date).format("YYYYMMDD") : '';
        return res;
      },
      changeFeeCd(){
        this.info.feeCd = this.selectedFeeCd.code;
        this.info.feeCdNm = this.selectedFeeCd.codeNm;
        this.info.feeAmt = this.selectedFeeCd.etcMeta2;
      },

     async sendKakaoTalk(paramList){
        let dstArr = [];
        paramList.forEach((data)=>{
          dstArr.push({
            Company: "고려대학교교우회",
            Name: data.memberHnm,
            Phone: data.cellular,
            Replace_Datas: [{Key:"#{이름}",Value:data.memberHnm},{Key:"#{기타1}",Value: data.feeDate},{Key:"#{기타2}",Value:data.feeCdNm},{Key:"#{기타3}",Value:formatter.getCurrency(data.feeAmt)+'원'}]
          })
        });

        try {
          let apiparams = {
            UserID : "kuaa1905",
            UserPW : "kou1905!",
            Service : "ATALK",
            Type : "Send",
            Fail_To : "LMS",
            Subject : "회비납부안내",
            Template_Seq : "4765",
            Callback : "15881905",
            Fail_To_Template : "1",
            //Main_Text : "LMS로 전환됩니다.",
            Destination : JSON.stringify(dstArr)
          }

          return await kuaaApi.sendServer2(
              "https://balsong.com/Linkage/API/",
              apiparams,
              "post"
          );

        }catch{
          //console.log("======= exception ========");
          // return false시 trnsaction 미발생
          return true;
        }
      }
    }
  };
</script>

<style>

</style>